module.exports = __webpack_public_path__ + "eef5a18199939d306c11b75323c7fe5c.svg";